import React from 'react';
import { Typography, Box, Stack } from '@mui/material';

const SolidBar = ({ sx }) => <Box sx={{ backgroundColor: '#E0E0E0', borderRadius: 1, height: '1.5em', minWidth: '100px', minHeight: '1.5em', flex: 1, ...sx }} />;
const OutlineBar = () => <Box sx={{ border: 2, borderColor: '#59BFF3', opacity: 0.25, borderRadius: 1, height: '2em', minWidth: '100px', flex: 1 }} />;
const OutlineBox = ({ children }) => <Box sx={{ border: 1, borderColor: '#CED5E9', borderRadius: 1, width: '100%', minWidth: '200px', flex: 1, padding: 1, backgroundColor: '#FEFEFE' }}>{children}</Box>;

const ContentPlaceholer = ({ props }) => {
    return (
        <Box sx={{ backgroundColor: 'rgb(247,248,251)', padding: 1, borderRadius: 1, ...props?.sx }}>
            <Stack spacing={2} sx={{ marginBottom: '-6em' }}>
                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" alignItems="center">
                    <SolidBar sx={{ minWidth: '20vw' }} />
                    {Array(7)
                        .fill()
                        .map((_, i) => (
                            <OutlineBar key={`header-outline-${i * 1}`} />
                        ))}
                </Stack>
                <Stack direction="row" spacing={3} useFlexGap flexWrap="wrap" alignItems="flex-start" sx={{ maxHeight: '9em', overflow: 'hidden' }}>
                    <Stack flex="1 0 10vw" spacing={2}>
                        <OutlineBox>
                            <Stack flex={1} spacing={1}>
                                <SolidBar />
                                <SolidBar sx={{ width: '65%' }} />
                            </Stack>
                        </OutlineBox>
                        <OutlineBox>
                            <Stack flex={1} spacing={1}>
                                {Array(4)
                                    .fill()
                                    .map((_, i) => (
                                        <SolidBar key={`1-1-${i * 1}`} />
                                    ))}
                            </Stack>
                        </OutlineBox>
                    </Stack>
                    <Stack flex="1 0 10vw">
                        <OutlineBox>
                            <Stack direction="row" useFlexGap spacing={1}>
                                <Stack flex="1 1 10vw" spacing={1}>
                                    {Array(4)
                                        .fill()
                                        .map((_, i) => (
                                            <SolidBar key={`2-1-${i * 1}`} />
                                        ))}
                                </Stack>
                                <Stack flex={1} spacing={1}>
                                    {Array(4)
                                        .fill()
                                        .map((_, i) => (
                                            <SolidBar key={`2-2-${i * 1}`} />
                                        ))}
                                </Stack>
                                <Stack flex={1} spacing={1}>
                                    {Array(4)
                                        .fill()
                                        .map((_, i) => (
                                            <SolidBar key={`2-3-${i * 1}`} sx={{ backgroundColor: '#EEEEEE' }} />
                                        ))}
                                </Stack>
                            </Stack>
                        </OutlineBox>
                    </Stack>
                    <Stack flex="1">
                        <OutlineBox>
                            <Stack flex={1} spacing={1}>
                                {Array(13)
                                    .fill()
                                    .map((_, i) => (
                                        <SolidBar key={`3-${i * 1}`} sx={{ height: '1em', minHeight: '1em' }} />
                                    ))}
                            </Stack>
                        </OutlineBox>
                    </Stack>
                </Stack>
                <Stack alignItems="center" justifyContent="center" sx={{ background: 'linear-gradient(180deg, rgba(247,248,251,0) 0%, rgba(247,248,251,1) 50%, rgba(247,248,251,1) 100%)', paddingTop: '6em', paddingBottom: '2em', marginLeft: '-8px', transform: 'translateY(-6em)' }}>
                    <Typography variant="h4" color="#95A2C7">
                        {props?.message}
                    </Typography>
                </Stack>
            </Stack>
        </Box>
    );
};

export default ContentPlaceholer;
